import React from 'react';
import { Copy, Box, H6 } from '@honda-canada/design-system-react';
import { useTranslation } from 'react-i18next';
import AvailabilityStatusBadge from '../TrimCardGrid/shared/AvailabilityStatusBadge';
import ColorPreviewPanel from './ColorPreviewPanel';
import ColorSwatches from './ColorSwatches';
import LoaderAndErrorContainer from './LoaderAndErrorContainer';
import themeStyles from './styles/AvailableColors.styles';
const Container = themeStyles.apply(Box, 'Container');
const SwatchContainer = themeStyles.apply(Box, 'SwatchContainer');
const Column = themeStyles.apply(Box, 'Column');
const Title = themeStyles.apply(Copy, 'Title');
const SwatchTitle = themeStyles.apply(Copy, 'SwatchTitle');
const Subtitle = themeStyles.apply(Copy, 'Subtitle');
const AvailableColorsUI = ({ title, subtitle, extColorSwatch, intColorSwatch, inventoryStatus, intColorAssetUrl, isPaymentFetching = false, isPaymentError = false, }) => {
    const { t } = useTranslation();
    const extColor = {
        colorName: extColorSwatch.name,
        hexValue: extColorSwatch.color,
    };
    const intColor = {
        colorName: intColorSwatch.name,
        url: intColorAssetUrl,
    };
    return (React.createElement(Container, { "data-testid": "cy-availability-info" },
        React.createElement(Column, null,
            React.createElement(Title, { size: "subheading", "data-testid": "cy-available-colors-title" }, title),
            React.createElement(AvailabilityStatusBadge, { status: inventoryStatus }),
            React.createElement(Subtitle, { size: "regular", "data-testid": "cy-availability-subtitle" }, subtitle),
            React.createElement(SwatchContainer, null,
                React.createElement(SwatchTitle, { size: "small", "data-testid": "cy-ext-color-swatch-title" }, t('Shared.Common.exteriorColoursLabel')),
                React.createElement(SwatchTitle, { size: "small", "data-testid": "cy-int-color-swatch-title" }, t('Shared.Common.interiorColoursLabel')),
                React.createElement(LoaderAndErrorContainer, { showError: isPaymentError, showLoader: isPaymentFetching, isLoaderFullWidth: true },
                    React.createElement(ColorSwatches, { swatches: [extColorSwatch, intColorSwatch], testIds: ['cy-availability-ext-color-swatch', 'cy-availability-int-color-swatch'] })))),
        React.createElement(Column, null,
            React.createElement(H6, { mb: "m" }, t('Shared.Common.intExtColoursSelectedLabel')),
            React.createElement(LoaderAndErrorContainer, { showError: isPaymentError, showLoader: isPaymentFetching },
                React.createElement(ColorPreviewPanel, { extColor: extColor, intColor: intColor })))));
};
export default AvailableColorsUI;
